<template>
  <v-row class="d-inline d-md-flex">
    <v-col xs="12" md="12">
      <v-card elevation="8">
        <v-card-title class="overline">
          Unform
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-chip-group multiple column>
            <draggable v-model="groupCard.unform" group="team" @start="drag=true" @end="drag=false" @change="drap_n_drop">
              <v-chip outlined pill v-for="(tag, index) in groupCard.unform" :key="index + tag.name" @click="click_player(tag)">
                <v-avatar left>
                  <v-img :src="tag.avatar"></v-img>
                </v-avatar>
                {{ tag.name }} - {{tag.class}}
                <v-icon v-if="tag.leader" color="grey" right>mdi-label</v-icon>
                <v-icon v-if="tag.class == 'TE'" dark right>mdi-christianity</v-icon>
                <v-icon v-if="tag.class == 'RA'" v right>mdi-pistol</v-icon>
              </v-chip>
            </draggable>
          </v-chip-group>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col :md="size" v-for="(team, index) in groupCard.list" :key="index + team.name">
      <v-card elevation="8">
        <v-card-title>
          <v-chip dark label :color="team.color" class="overline">
            {{team.name}}
          </v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-chip-group dark multiple column>
              <draggable v-model="groupCard.group_player[team.name]" group="team" @start="drag=true" @end="drag=false">
                <v-chip :color="team.color" pill v-for="(tag, index) in groupCard.group_player[team.name]" :key="index + tag.name" @click="click_player(tag)">
                  <v-avatar left>
                    <v-img :src="tag.avatar"></v-img>
                  </v-avatar>
                  {{ tag.name }} - {{tag.class}}
                  <v-icon v-if="tag.leader" color="white" right>mdi-label</v-icon>
                  <v-icon v-if="tag.class == 'TE'" dark right>mdi-christianity</v-icon>
                  <v-icon v-if="tag.class == 'RA'" v right>mdi-pistol</v-icon>
                </v-chip>
              </draggable>
            </v-chip-group>
        </v-card-text>
      </v-card>
    </v-col>
    <editDialog/>
  </v-row>
</template>

<script>
import draggable from 'vuedraggable'
import editDialog from '../../dialog/editDialog/editDialog.vue'
const firebase = require('firebase')
const database = firebase.database()

export default {
  name: 'groupCard',
  components: {
    draggable,
    editDialog
  },
  data: () => ({
    groupCard: {},
    size: 0,
    edit_status: false
  }),
  created () {
    this.size = this.$store.state.app.size
    this.edit_status = this.$store.state.editDialog.state
    console.log(this.$store.state.editDialog.status)
    this.groupCard = this.$store.state.groupCard
    this.groupCard.list.forEach(h => {
      if (this.groupCard.group_player[h.name].length === 0) {
        this.groupCard.group_player[h.name].push({
          avatar: 'https://s1.zerochan.net/Matoi.%28PSO2%29.600.2266422.jpg',
          class: 'GM',
          leader: true,
          name: 'Not Assign'
        })
      } else {
        this.groupCard.group_player[h.name] = this.groupCard.group_player[h.name].filter(item => item.class !== 'GM')
      }
    })
  },
  methods: {
    drap_n_drop () {
      this.groupCard.list.forEach(h => {
        if (this.groupCard.group_player[h.name].length === 0) {
          this.groupCard.group_player[h.name].push({
            avatar: 'https://s1.zerochan.net/Matoi.%28PSO2%29.600.2266422.jpg',
            class: 'GM',
            leader: true,
            name: 'Not Assign'
          })
        } else {
          let status = false
          this.groupCard.group_player[h.name].forEach(item => {
            if (item.class === 'GM') status = true
          })
          if (this.groupCard.group_player[h.name].length > 1 && status) this.groupCard.group_player[h.name] = this.groupCard.group_player[h.name].filter(item => item.class !== 'GM')
        }
      })
      console.log(this.groupCard.group_player)
    },
    click_player (item) {
      if (this.$store.state.controlBar.edit_status) {
        let data = {
          status: true,
          item: item
        }
        this.$store.commit('setEditDialog', data)
      }
    }
  }
}
</script>

<style scoped>

</style>
